import React, { PropTypes } from "react";
import classnames from "classnames";
import DecadePanel from "../decade/DecadePanel";
const ROW = 4;
const COL = 3;

function goYear(direction) {
  const value = this.state.value.clone();
  value.addYear(direction);
  this.setState({
    value
  });
}

function chooseYear(year) {
  const value = this.state.value.clone();
  value.setYear(year);
  value.rollSetMonth(this.state.value.getMonth());
  this.props.onSelect(value);
}

export default class YearPanel extends React.Component {
  constructor(props) {
    super(props);
    this.prefixCls = `${props.rootPrefixCls}-year-panel`;
    this.state = {
      value: props.value || props.defaultValue
    };
    this.nextDecade = goYear.bind(this, 10);
    this.previousDecade = goYear.bind(this, -10);
    ["showDecadePanel", "onDecadePanelSelect"].forEach(method => {
      this[method] = this[method].bind(this);
    });
  }

  onDecadePanelSelect(current) {
    this.setState({
      value: current,
      showDecadePanel: 0
    });
  }

  getYears() {
    const value = this.state.value;
    const currentYear = value.getYear();
    const startYear = parseInt(currentYear / 10, 10) * 10;
    const previousYear = startYear - 1;
    const endYear = startYear + 9;
    const years = [];
    let index = 0;
    for (let rowIndex = 0; rowIndex < ROW; rowIndex++) {
      years[rowIndex] = [];
      for (let colIndex = 0; colIndex < COL; colIndex++) {
        const year = previousYear + index;
        let content;
        if (year < startYear) {
          content = "";
        } else if (year > endYear) {
          content = "";
        } else {
          content = String(year);
        }
        years[rowIndex][colIndex] = {
          content,
          year,
          title: content
        };
        index++;
      }
    }
    return years;
  }

  showDecadePanel() {
    this.setState({
      showDecadePanel: 1
    });
  }

  render() {
    const props = this.props;
    const value = this.state.value;
    const locale = props.locale;
    const years = this.getYears();
    const currentYear = value.getYear();
    const startYear = parseInt(currentYear / 10, 10) * 10;
    const endYear = startYear + 9;
    const prefixCls = this.prefixCls;

    const yeasEls = years.map((row, index) => {
      const tds = row.map(yearData => {
        const classNameMap = {
          [`${prefixCls}-cell`]: 1,
          [`${prefixCls}-selected-cell`]: yearData.year === currentYear,
          [`${prefixCls}-last-decade-cell`]: yearData.year < startYear,
          [`${prefixCls}-next-decade-cell`]: yearData.year > endYear
        };
        let clickHandler;
        if (yearData.year < startYear) {
          clickHandler = this.previousDecade;
        } else if (yearData.year > endYear) {
          clickHandler = this.nextDecade;
        } else {
          clickHandler = chooseYear.bind(this, yearData.year);
        }
        return (
          <td
            ecId={`${props.ecId}_td@znb1yp@${yearData.content}`}
            role="gridcell"
            title={yearData.title}
            key={yearData.content}
            onClick={clickHandler}
            className={classnames(classNameMap)}
          >
            <a className={`${prefixCls}-year`}>{yearData.content}</a>
          </td>
        );
      });
      return (
        <tr key={index} role="row">
          {tds}
        </tr>
      );
    });

    let decadePanel;
    if (this.state.showDecadePanel) {
      decadePanel = (
        <DecadePanel
          ecId={`${props.ecId}_DecadePanel@y4cukv`}
          locale={locale}
          value={value}
          rootPrefixCls={props.rootPrefixCls}
          onSelect={this.onDecadePanelSelect}
        />
      );
    }

    return (
      <div className={this.prefixCls}>
        <div>
          <div className={`${prefixCls}-header`}>
            <a
              ecId={`${props.ecId}_a@2xsnod`}
              role="button"
              className={`${prefixCls}-prev-decade-btn`}
              onClick={this.previousDecade}
              title={locale.previousDecade}
            >
              «
            </a>
            <a
              ecId={`${props.ecId}_a@jyny7n`}
              role="button"
              className={`${prefixCls}-decade-select`}
              onClick={this.showDecadePanel}
              title={locale.decadeSelect}
            >
              <span className={`${prefixCls}-decade-select-content`}>
                {startYear}-{endYear}
              </span>
              <span className={`${prefixCls}-decade-select-arrow`}>x</span>
            </a>

            <a
              ecId={`${props.ecId}_a@6ggkfb`}
              role="button"
              className={`${prefixCls}-next-decade-btn`}
              onClick={this.nextDecade}
              title={locale.nextDecade}
            >
              »
            </a>
          </div>
          <div className={`${prefixCls}-body`}>
            <table className={`${prefixCls}-table`} cellSpacing="0" role="grid">
              <tbody className={`${prefixCls}-tbody`}>{yeasEls}</tbody>
            </table>
          </div>
        </div>
        {decadePanel}
      </div>
    );
  }
}

YearPanel.propTypes = {
  rootPrefixCls: PropTypes.string,
  value: PropTypes.object,
  defaultValue: PropTypes.object
};

YearPanel.defaultProps = {
  onSelect() {}
};



// WEBPACK FOOTER //
// ./_rc-calendar-5.6.2/src/year/YearPanel.jsx